export const primaryText = '#0D151F';
